import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import iconRetina from "leaflet/dist/images/marker-icon-2x.png";
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";

// Fix default marker icon paths broken by webpack bundling.
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({ iconRetinaUrl: iconRetina, iconUrl: icon, shadowUrl: iconShadow });

// Imperative Leaflet map: shows event location, permitted radius and (optionally) the musician's position.
export default function CheckinMap({ event, me, radius = 500 }) {
  const elRef = useRef(null);
  const mapRef = useRef(null);
  const layersRef = useRef({});

  useEffect(() => {
    if (!elRef.current || mapRef.current) return;
    const center = event ? [event.lat, event.lng] : me ? [me.lat, me.lng] : [-23.55, -46.63];
    const map = L.map(elRef.current, { attributionControl: false, zoomControl: true }).setView(center, 15);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", { maxZoom: 19 }).addTo(map);
    mapRef.current = map;
    return () => { map.remove(); mapRef.current = null; };
  }, []); // eslint-disable-line

  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;
    Object.values(layersRef.current).forEach((l) => l && map.removeLayer(l));
    layersRef.current = {};
    const bounds = [];
    if (event && event.lat != null) {
      layersRef.current.circle = L.circle([event.lat, event.lng], {
        radius, color: "#FF4D00", fillColor: "#FF4D00", fillOpacity: 0.12, weight: 1.5,
      }).addTo(map);
      layersRef.current.ev = L.marker([event.lat, event.lng]).addTo(map).bindPopup("Local do evento");
      bounds.push([event.lat, event.lng]);
    }
    if (me && me.lat != null) {
      layersRef.current.me = L.circleMarker([me.lat, me.lng], {
        radius: 7, color: "#00F0FF", fillColor: "#00F0FF", fillOpacity: 0.9, weight: 2,
      }).addTo(map).bindPopup("Você está aqui");
      bounds.push([me.lat, me.lng]);
    }
    if (bounds.length === 2) map.fitBounds(bounds, { padding: [40, 40], maxZoom: 16 });
    else if (bounds.length === 1) map.setView(bounds[0], 15);
    setTimeout(() => map.invalidateSize(), 100);
  }, [event, me, radius]);

  return <div ref={elRef} data-testid="checkin-map" className="h-56 w-full rounded-sm overflow-hidden border border-white/10 z-0" />;
}
